// Thresholds for marking a comment read.
//
// The closest industry standard is MRC viewability: content counts as seen at
// >= 50% of its pixels visible for >= 1 continuous second (display) or 2
// seconds (video). 2s is the conservative end of that range. Below 1s an
// accidental click clears a backlog the user was keeping on purpose; above
// ~3s users report "I read it and it is still marked unread".
export const VISIBILITY_RATIO = 0.5;
export const DWELL_MS = 2000;

// Scrolling past ten comments should be one request, not ten.
export const FLUSH_DEBOUNCE_MS = 500;
